'use client';

import { useTranslations } from 'next-intl';
import EmojiPicker, { Categories, EmojiClickData } from 'emoji-picker-react';
import './emoji-selector.css';

interface EmojiSelectorProps {
  onEmojiSelect: (value: EmojiClickData) => void;
}

export function EmojiSelector({ onEmojiSelect }: EmojiSelectorProps) {
  const t = useTranslations('shared');
  return (
    <div className="emoji-selector">
      <EmojiPicker
        width="100%"
        height="50vh"
        lazyLoadEmojis={true}
        previewConfig={{
          showPreview: false,
        }}
        searchPlaceHolder={t('emoji-selector.search_emoji')}
        onEmojiClick={onEmojiSelect}
        categories={[
          { category: Categories.SMILEYS_PEOPLE, name: 'Smileys & People' },
          { category: Categories.ANIMALS_NATURE, name: 'Animals & Nature' },
          { category: Categories.FOOD_DRINK, name: 'Food & Drink' },
          { category: Categories.TRAVEL_PLACES, name: 'Travel & Places' },
          { category: Categories.ACTIVITIES, name: 'Activities' },
          { category: Categories.OBJECTS, name: 'Objects' },
          { category: Categories.SYMBOLS, name: 'Symbols' },
          { category: Categories.FLAGS, name: 'Flags' },
        ]}
      />
    </div>
  );
}
